// 'jsx-closing-bracket-location': 1
import React from 'react';
import PropTypes from 'prop-types';
import ReactCurrencyInput from 'react-currency-input-field';

// eslint-disable-next-line no-unused-vars
import currencycss from './currency.css';

function CurrencyInput({
  title,
  value,
  onValueChange,
  maxLength,
  errorMessage,
  required,
  className,
  label,
}) {
  const handleOnChange = v => {
    if (onValueChange) {
      onValueChange(v);
    }
  };
  const id = 'currency-' + value;

  return (
    <main>
      <div
        className={
          errorMessage
            ? 'cdc-currency currency-error ' + className
            : 'cdc-currency ' + className
        }
      >
        <header id={id}>{title}</header>
        <ReactCurrencyInput
          name={title}
          className="currency-input"
          placeholder="$ Please enter amount"
          prefix="$ "
          allowNegativeValue={false}
          defaultValue={value}
          decimalsLimit={2}
          maxLength={maxLength}
          onValueChange={handleOnChange}
          decimalScale={2}
          value={value}
          required={required}
          aria-labelledby={label || id}
        />
        {errorMessage && <p className="error"> {errorMessage} </p>}
      </div>
    </main>
  );
}

CurrencyInput.propTypes = {
  title: PropTypes.string,
  value: PropTypes.number,
  onValueChange: PropTypes.func,
  maxLength: PropTypes.number,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
};

export default CurrencyInput;
